import { render, staticRenderFns } from "./CountryTag.vue?vue&type=template&id=06a635e9&scoped=true"
import script from "./CountryTag.vue?vue&type=script&lang=js"
export * from "./CountryTag.vue?vue&type=script&lang=js"
import style0 from "./CountryTag.vue?vue&type=style&index=0&id=06a635e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a635e9",
  null
  
)

export default component.exports